"use client";

import { Check, Coins } from "lucide-react";

import { Badge } from "../../../shadcn/ui/badge";
import { DetailsTabProps } from "./types";
import { PaidPlanCard } from "./PaidPlanCard";
import dayjs from "@punchup/utils/dayjs";

export function DetailsTab({
  balance,
  activeSubscription,
  onCancelSubscription,
  onUpdatePaymentMethod,
  onChangePlan,
  onRefill,
  isDesktop,
}: DetailsTabProps) {
  return (
    <div>
      {/* Title — hidden on mobile since UnderlineTabs already shows active tab */}
      {isDesktop !== false && (
        <h2 className="text-primary-blue text-xl font-semibold">
          Messaging Credits
        </h2>
      )}

      {/* Balance card */}
      <div className="mt-5 w-full sm:w-fit rounded-[14px] border border-[#E7E7E7] px-5 py-4">
        <p className="text-xs font-semibold uppercase tracking-wider text-[#6A7282]">
          YOUR BALANCE
        </p>
        <div className="mt-1 flex items-center gap-2">
          <Coins className="h-5 w-5 text-[#38A93C]" />
          <span className="text-3xl font-bold text-[#38A93C]">
            {balance.totalBalance.toLocaleString()}
          </span>
          <span className="text-sm text-[#38A93C]">credits</span>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-[#E7E7E7] my-6" />

      {/* Your Plan heading */}
      <h3 className="text-lg font-semibold text-[#29333C]">Your Plan</h3>

      {activeSubscription ? (
        <PaidPlanCard
          subscription={activeSubscription}
          onCancelSubscription={onCancelSubscription}
          onUpdatePaymentMethod={onUpdatePaymentMethod}
          onChangePlan={onChangePlan}
          onRefill={onRefill}
          isDesktop={isDesktop}
        />
      ) : (
        /* Free Tier plan card */
        <div className="mt-4 w-full sm:max-w-[357px] rounded-[10px] border border-[#A4A6A8] px-4 py-4 space-y-3">
          <Badge className="bg-[#FE5E25]/10 text-[#FE5E25] border-0 hover:bg-[#FE5E25]/10">
            Free Tier
          </Badge>
          <p className="mt-1 text-sm font-normal text-[#787B7E]">
            Credits refill on{" "}
            {dayjs().add(1, "month").startOf("month").format("MMMM D")}
          </p>
          <p className="text-2xl font-bold text-[#29333C]">
            USD 0.00{" "}
            <span className="text-base font-normal text-[#787B7E]">
              / month
            </span>
          </p>
          <div className="space-y-2">
            {[
              "Free emails to fans who signed up on Punchup",
              "1,000 credits included every month",
              "Credit cost depends on SMS vs. email",
            ].map((item) => (
              <div key={item} className="flex items-center gap-2">
                <Check className="h-4 w-4 text-[#29333C] stroke-[2.5]" />
                <span className="text-sm text-[#29333C]">{item}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
